import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ValueReferenceIndexComponent } from './crud-index/crud-index.component';
import { ValueReferenceCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: ValueReferenceIndexComponent,
  },
  {
    path: 'create',
    component: ValueReferenceCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: ValueReferenceCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: ValueReferenceCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ValueReferencesRoutingModule {}
